














import { Component, Emit, Mixins, Prop } from "vue-property-decorator";
import { IReplaceParameters } from "../../../../../../domain/document";
import { InjectedObjectPresentableMixin } from "./mixins";
import { default as InjectedObjectGroundDrawer } from "./InjectedObjectGroundDrawer.vue";

@Component({
  components: {
    InjectedObjectGroundDrawer,
  }
})
export default class InjectedObjectDrawer extends Mixins(InjectedObjectPresentableMixin) {
  @Prop()
  isSelected: boolean;

  @Prop()
  replaceParameters: IReplaceParameters;

  get additionalClasses(): string[] {
    return [
      this.isSelected ? "selected" : ""
    ].filter(c => !!c);
  }

  onClicked() {
    this.click();
  }

  @Emit()
  click(): void {}
}
